import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseDueDateEarlierThanIssueDateError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.due-date-earlier-than-issue-date-error.message');
    }
}
